module.exports = __webpack_public_path__ + "static/media/AcomplamientoJM-baldor.2574b41c.png";